export const BASE_URL = "https://mna-computer-manufacturer.onrender.com";

// export const BASE_URL = "http://localhost:5000";
